import { render } from "./OnlineOrders.vue?vue&type=template&id=10a17adc"
import script from "./OnlineOrders.vue?vue&type=script&lang=js"
export * from "./OnlineOrders.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mattday/Sites/swallowdental.co.uk/app/code/SwallowDental/CustomAccount/view/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"web/vue/screens/OnlineOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10a17adc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10a17adc', __exports__)) {
    api.reload('10a17adc', __exports__)
  }
  
  module.hot.accept("./OnlineOrders.vue?vue&type=template&id=10a17adc", () => {
    api.rerender('10a17adc', render)
  })

}


export default __exports__